import { useQuery, gql } from "@apollo/client"

const ACTIVE_NOTICES_QUERY = gql`
  query ActiveNotices($filter: ActiveNoticesFilterInput) {
    activeNotices(filter: $filter) {
      id
      severity
      scope
      message
      externalUrl
      startAt
      endAt
    }
  }
`

// Poll every 2 minutes (120000ms)
const POLL_INTERVAL = 1000 * 60 * 2

const useQueryActiveNotices = (options = {}) =>
  useQuery(ACTIVE_NOTICES_QUERY, {
    pollInterval: POLL_INTERVAL,
    ...options
  })

export { useQueryActiveNotices, ACTIVE_NOTICES_QUERY }
